module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAANAAkDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAABwj/xAApEAACAQIEAgsAAAAAAAAAAAABAgMEBQAGByEREggTFRYxVWRxkaPh/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AHLXTpEXjJWsOUrHbAIMt1tQkVwrKmCSIk9cUm5WYDZEKsCo4Hj4kbYpbtSj8xX5xOetGitRnCqr55b+sTLO7xFqEO0QLbgHnHthm7p+r+v9wH//2Q=="


//////////////////
// WEBPACK FOOTER
// ./static/Resized_Images/00283r.jpg
// module id = iTn9
// module chunks = 1